import React, { useEffect, useState, useContext } from "react";
import {
  Navbar,
  Container,
  Nav,
  NavDropdown,
  Offcanvas,
  Spinner
} from "react-bootstrap";
import { Link } from "react-router-dom";
import api from "../admin/api/api"; 
import { ShopContext } from "../context/ShopContext";
import { image_base_url } from "../admin/api/api";
import "./CategoryNavbar.scss";

function CategoriesNavbar({ onCategoryClick, onSubCategoryClick }) {
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const { shop } = useContext(ShopContext);
  const [showCategory, setShowCategory] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const [catRes, subRes] = await Promise.all([
        api.get("/Categories"),
        api.get("/SubCategories"),
      ]);
      setCategories(catRes.data);
      setSubCategories(subRes.data);
    } catch (error) {
      console.error("Navbar API Error:", error);
    } finally {
      setLoading(false);
    }
  };

  // Get subcategories for a category
  const getSubCategories = (categoryId) => {
    return subCategories.filter(sub => sub.categoryId === categoryId);
  };

  return (
    <Navbar expand="lg" className="category-navbar">
      <Container className="position-relative">
        <div className="mobile-toggle d-lg-none">
          <Navbar.Toggle
            aria-controls="offcanvasNavbar"
            className="toggle-icon"
            onClick={() => setShowCategory(true)}   // ⭐ open menu
          />
          <span style={{ fontWeight: "bold", color: "white" }}>Categories</span>
        </div>

        <Navbar.Offcanvas
          id="offcanvasNavbar"
          placement="start"
          responsive="lg"
          show={showCategory}                // ⭐ control open/close
          onHide={() => setShowCategory(false)} // ⭐ close button
          className="category-offcanvas"
        >
          <Offcanvas.Header closeButton style={{ borderBottom: "2px solid gray" }}>
            <img src={ shop?.logoUrl ? `${image_base_url}${shop.logoUrl}`  : "/images/swara-logo-smbg.png" } 
            alt={shop?.shopName || "Store Logo"} style={{ height: "40px" }} />
          </Offcanvas.Header>

          <Offcanvas.Body>
            <div className="w-100 d-lg-flex justify-content-lg-center">
              <Nav className="category-links">

                {/* All Products */}
                <Nav.Link as={Link} to="/productlist" 
                onClick={() => { onCategoryClick(null); onSubCategoryClick(null); setShowCategory(false); }}>
                  All Items
                </Nav.Link>

                {/* Loading */}
                {loading && <Spinner animation="border" size="sm" className="px-3" />}

                {/* Dynamic Categories */}
                {!loading && categories.map(category => {
                  const subs = getSubCategories(category.categoryId);

                  if (subs.length > 0) {
                    return (
                      <NavDropdown key={category.categoryId} title={category.categoryName} id={`dropdown-${category.categoryId}`}>
                        {subs.map(sub => (
                          <NavDropdown.Item
                            key={sub.subCategoryId}
                            as={Link}
                            to={`/productlist?subcategory=${sub.subCategoryId}`}
                            onClick={() => setShowCategory(false)}
                          >
                           {sub.subCategoryName}
                          </NavDropdown.Item>
                        ))}
                      </NavDropdown>
                    );
                  }

                  return (
                    <Nav.Link
                      key={category.categoryId}
                      as={Link}
                      to={`/productlist?category=${category.categoryId}`}
                      onClick={() => setShowCategory(false)}
                    >
                      {category.categoryName}
                    </Nav.Link>
                  );
                })}

              </Nav>
            </div>
          </Offcanvas.Body>
        </Navbar.Offcanvas>

      </Container>
    </Navbar>
  );
}

export default CategoriesNavbar;